import { defineMessages } from 'react-intl';

export default defineMessages({
  callAITitle: 'You have been logged out. Please login again to continue.',
  reloadBtn: 'Reload',
});
